// extracted by mini-css-extract-plugin
module.exports = {"vGray0":"#b9b9dc","group":"MessengerMessageGroup_group__2g_tw","dateWrap":"MessengerMessageGroup_dateWrap__3olcK","date":"MessengerMessageGroup_date__RCJkV"};